import {Col, Container, Row} from "react-bootstrap";
import {useEffect, useRef} from "react";
import animationData from "./animal.json";
import Lottie, {LottieRefCurrentProps} from "lottie-react";
import styles from "./HelloSection.module.scss";

const HelloSection = () => {
    const animationRef = useRef<LottieRefCurrentProps>(null);

    useEffect(() => {
        if (animationRef.current) {
            animationRef.current.play();
        }
    }, []);

    return (
        <Container className={styles.container}>
            <Row className={styles.customRow}>
                <Col
                    xs={{span: 12, order: "first"}}
                    md={{span: 4, order: "last"}}
                    xl={4}
                    className={styles.animationCol}
                >
                    <Lottie
                        animationData={animationData}
                        loop={true}
                        autoplay={true}
                        className={styles.animation}
                        lottieRef={animationRef}
                    />
                </Col>

                <Col
                    xs={{span: 12, order: "last"}}
                    md={{span: 8, order: "first"}}
                    xl={8}
                    className={styles.textCol}
                >
                    <div className={styles.textWrapper}>
                        <h1 className={styles.title}>
                            Питомцы —<br/>
                            это наше все,
                        </h1>
                        <p className={styles.subtitle}>
                            Доверьте их нам — мы поможем
                        </p>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default HelloSection;
